import React from 'react'

const GoogleMapContainer = () => (
    <a
        href="https://www.google.hr/maps/dir//LaCop+Centar,+52440,+Pore%C4%8D/@45.2303601,13.6046979,18z/data=!4m15!1m6!3m5!1s0x477c979b69949413:0xfc362427a13056d7!2sLaCop+Centar!8m2!3d45.2303847!4d13.6051539!4m7!1m0!1m5!1m1!1s0x477c979b69949413:0xfc362427a13056d7!2m2!1d13.6051539!2d45.2303847?hl=en"
        target="_blank"
        rel="noopener noreferrer"
    >
        <div className="google-map-container">
            <div className="dot google-map-dot">
                <div className="centraldot"></div>
                <div className="wave"></div>
                <div className="wave2"></div>
            </div>
        </div>
    </a>
)

export default GoogleMapContainer



// WEBPACK FOOTER //
// ./src/scripts/containers/GoogleMapContainer.jsx